<app-header></app-header>
<div class="container-fluid">
    <div class="download_pod red">
        <div class="row">
            <div class="col-md-6">
                <p>गेम खेलने के लिए Play Online Delhi एप्लीकेशन डाउनलोड करे डाउनलोड करने के लिए डाउनलोड पर क्लिक करे </p>
            </div>
            <div class="col-md-6 align-middle">
                <div class="download_now">
                    <p>Get Play Online Delhi (POD) App</p>
                    <a href="../../../assets/apk/pod.apk" class="btn btn-outline-light button download">
                        <img src="../../../assets/images/rapidjpg.png" class="img-fluid"/> <span>Download Now</span>
                    </a>
                </div>
            </div>
        </div>
    </div> 
</div>
<!-- <div class="container">
    <div style="padding:20px;">
        <h4 class="blinkMsg text-center">आपसे एक विनती है अगर आप गेम खेलते है तो आप इस app को डाउनलोड कर लो मार्किट में fake application और भी उपलब्ध है  ये मैसेज आपको बताने के लिए किया है क्यूंकि बहुत जल्द fake application  बंद कर दी जाएगी
            जरूरी सुचना आपको pod से सम्बंधित कोई मैसेज मिलता है वे fake Message है POD आपकी सेवा में उपस्थित है धन्यवाद</h4>
    </div>
</div> -->
<div class="today mb-3" id="result">
    <div class="container-fluid">
        <div class="row well">
            <div class="col center" *ngIf="showDeep">
                <app-deep></app-deep>
            </div>
            <div class="col">
                <div class="card align-middle center align-middle p-3">
                    <h5>Today Latest Result</h5>
                    <h1 class="last">{{data && data.latest?data.latest.result:'--'}}</h1>
                    <h4>{{data.latest?data.latest.game.gamename.name:'--'}}</h4>
                </div>
            </div>
            <div class="col center mt-5 hide" *ngIf="showDeep">
                <app-deep></app-deep>
            </div>
        </div>
        <div class="result-row row">
            <div class="col-md-2 col-4" *ngFor="let item of data.allgameresult">
                <div class="box" style="background-color:{{item.color}}">
                    <div class="row">
                        <div class="col">
                            <h2>({{item.yesterday}})</h2>
                            <p>Yesterday</p>
                        </div>
                        <div class="col">
                            <h2>{{item.number}}</h2>
                            <p>Today</p>
                        </div>
                    </div>
                    <div class="row game_name">
                        <div class="col">
                            <p>{{item.gamename.name}}</p>
                        </div>
                    </div>
                </div>
            </div>            
        </div>
    </div>
</div>
<div class="container-fluid mb-2">
    
<div class="download_pod pof">
    <div class="row">
        <div class="col-md-6">
            <p>गेम खेलने के लिए 1x90 एप्लीकेशन डाउनलोड करे डाउनलोड करने के लिए डाउनलोड पर क्लिक करे </p>
        </div>
        <div class="col-md-6 align-middle">
            <div class="download_now">
                <p>Get 1x90 App</p>
                <a href="https://play.google.com/store/apps/details?id=com.diamond.mandi" class="btn btn-outline-light button download">
                    <img src="../../../assets/images/1x90.webp" class="img-fluid"/> <span>Download Now</span>
                </a>
            </div>
        </div>
    </div>
</div> 

<div class="download_pod red">
    <div class="row">
        <div class="col-md-6">
            <p>गेम खेलने के लिए Lottory Color एप्लीकेशन डाउनलोड करे डाउनलोड करने के लिए डाउनलोड पर क्लिक करे </p>
        </div>
        <div class="col-md-6 align-middle">
            <div class="download_now">
                <p>Get Lottory Color App</p>
                <a href="https://lottorycolor.com/" class="btn btn-outline-light button download">
                    <img src="../../../assets/images/lottorycolor.png" class="img-fluid"/> <span>Download Now</span>
                </a>
            </div>
        </div>
    </div>
</div> 

<div class="download_pod blue">
    <div class="row">
        <div class="col-md-6">
            <p>गेम खेलने के लिए Play Online Gali एप्लीकेशन डाउनलोड करे डाउनलोड करने के लिए डाउनलोड पर क्लिक करे </p>
        </div>
        <div class="col-md-6 align-middle">
            <div class="download_now">
                <p>Get Play Online Gali (POG) App</p>
                <a href="../../../assets/apk/pog.apk" class="btn btn-outline-light button download">
                    <img src="../../../assets/images/pog.png" class="img-fluid"/> <span>Download Now</span>
                </a>
            </div>
        </div>
    </div>
</div> 


<div class="download_pod pof">
    <div class="row">
        <div class="col-md-6">
            <p>रियल कॅश के साथ लूडो गेम खेलने के लिए PODLUDO Game डाउनलोड करे | डाउनलोड करने के लिए डाउनलोड पर क्लिक करे

            </p>
        </div>
        <div class="col-md-6 align-middle">
            <div class="download_now">
                <p>Get PODLUDO App</p>
                <a href="https://podludo.com" class="btn btn-outline-light button download">
                    <img src="../../../assets/images/podludo.png" class="img-fluid"/> <span>Download Now</span>
                </a>
            </div>
        </div>
    </div>
</div> 


<div class="download_pod yellow">
    <div class="row">
        <div class="col-md-6">
            <p>गेम खेलने के लिए PODBET51 एप्लीकेशन डाउनलोड करे डाउनलोड करने के लिए डाउनलोड पर क्लिक करे </p>
        </div>
        <div class="col-md-6 align-middle">
            <div class="download_now">
                <p>Get PODBET51 App</p>
                <a href="https://play.google.com/store/apps/details?id=com.podbet51" class="btn btn-outline-light button download">
                    <img src="../../../assets/images/podbet51.png" class="img-fluid"/> <span>Download Now</span>
                </a>
            </div>
        </div>
    </div>
</div> 




<div class="download_pod green">
    <div class="row">
        <div class="col-md-6">
            <p>गेम खेलने के लिए SG Company एप्लीकेशन डाउनलोड करे डाउनलोड करने के लिए डाउनलोड पर क्लिक करे </p>
        </div>
        <div class="col-md-6 align-middle">
            <div class="download_now">
                <p>Get SG Company App</p>
                <a href="../../../assets/apk/sgcompany.apk" class="btn btn-outline-light button download">
                    <img src="../../../assets/images/sg.png" class="img-fluid"/> <span>Download Now</span>
                </a>
            </div>
        </div>
    </div>
</div> 


<div class="download_pod yellow">
    <div class="row">
        <div class="col-md-6">
            <p>गेम खेलने के लिए MG Company एप्लीकेशन डाउनलोड करे डाउनलोड करने के लिए डाउनलोड पर क्लिक करे </p>
        </div>
        <div class="col-md-6 align-middle">
            <div class="download_now">
                <p>Get MG Company App</p>
                <a href="../../../assets/apk/mgcompany.apk" class="btn btn-outline-light button download">
                    <img src="../../../assets/images/mg.png" class="img-fluid"/> <span>Download Now</span>
                </a>
            </div>
        </div>
    </div>
</div> 
</div>

<!-- <div class="month-chart">
    <div class="container-fluid">
        <div class="header">
            <h3>Septumber 2020</h3>
        </div>
        <div class="table-responsive">
            <table class="table">
                <tr>
                    <th>Date</th>
                    <th>Manali</th>
                    <th>DESAWER</th>
                    <th>FARIDABAD</th>
                    <th>GHAZIABAD</th>
                    <th>GALI</th>
                    <th>KUBER BAZAR	</th>
                    <th>MAHALAKSHMI</th>
                    <th>KUBER MARKET</th>
                    <th>DUBAI MARKET</th>
                    <th>KINGPERRIS</th>
                </tr>
                <tr *ngFor="let item of [1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18,19,20,21,22,23,24,25,26,27,28,29,30]">
                    <td>{{item<10?'0'+item:item}}/09/2020</td>
                    <td>--</td>
                    <td>--</td>
                    <td>--</td>
                    <td>--</td>
                    <td>--</td>
                    <td>--</td>
                    <td>--</td>
                    <td>--</td>
                    <td>--</td>
                    <td>--</td>
                </tr>
            </table>
        </div>
    </div>
</div> -->

<!-- <div class="mobile-app">
    <img src="../../../assets/images/new-app-banner-slider-e1453239087304.png" class="img-fluid">
    <a href="" class="button"><img src="../../../assets/images/en_badge_web_generic.png"></a>
</div> -->

<!-- <div class="container">
    <div style="padding:20px;">
        <h4 class="blinkMsg text-center">आपसे एक विनती है अगर आप गेम खेलते है तो आप इस app को डाउनलोड कर लो मार्किट में fake application और भी उपलब्ध है  ये मैसेज आपको बताने के लिए किया है क्यूंकि बहुत जल्द fake application  बंद कर दी जाएगी
            जरूरी सुचना आपको pod से सम्बंधित कोई मैसेज मिलता है वे fake Message है POD आपकी सेवा में उपस्थित है धन्यवाद</h4>
    </div>
</div> -->

<div class="container" id="about">
    <div class="text-center">
        <h4>About</h4>
        <p>POD App or Play Online Delhi satta website lottery based game, it is currently renowned and largely taking part in game across the globe individuals are crazy playing this game 
            POD or Play Online delhi is getting popular day by day because pod is india's first online satta app and it is reliable for transperacy in transaction of money for satta bet. 
            Now currently individuals ought to rely on it and pod is the platform where individuals can try their Luck by selecting any number which they feel lucky for them for that particular day. The owner of the satta king game opens the satta result on a fix time on daily basis and all the players who have put their fortune on that particular number declared as winners,
            play online delhi , pod website helps the players to get the updates of all the satta king games of satta bazzar and articles related to this satta matka industry.</p>
    </div>
</div>

<div class="footer">
    <div class="container">
        <p class="text-center">
            Copyright &copy; PlayOnlineDelhi (POD) All Rights Reserved.
        </p>
    </div>
</div>